import type { Directive } from "vue";

const maxLength = 11;

const vPhone: Directive<HTMLInputElement> = {
  mounted(el) {
    const formatPhone = (value: string) => {
      let digits = value.replace(/\D/g, "");

      if (digits.length >= maxLength) digits = digits.slice(0, maxLength);

      if (digits.length !== maxLength && !digits.startsWith("1")) digits = "1" + digits;

      const parts: string[] = [];
      parts.push(digits[0]);
      if (digits.length > 1) parts.push(digits.slice(1, 4));
      if (digits.length > 4) parts.push(digits.slice(4, 7));
      if (digits.length > 7) parts.push(digits.slice(7));

      return parts.join(" ");
    };

    const handler = (input: HTMLInputElement) => {
      if (!input?.value) {
        return;
      }

      const formatted = formatPhone(input.value);
      input.value = formatted;
      input.dispatchEvent(new Event("input"));
    };

    const onInput = (e: Event) => {
      return handler(e.target as HTMLInputElement);
    };

    el.addEventListener("input", onInput);

    const input = el.querySelector("input");
    handler(input as HTMLInputElement);

    (el as any).__phoneHandler__ = onInput;
  },
  unmounted(el) {
    el.removeEventListener("input", (el as any).__phoneHandler__);
  },
};

export default vPhone;
